export { default as Login } from "./Login";
export { default as Registro } from "./Register";
export { default as Profile } from "./Profile";
export { default as ForgotPassword } from './forgot_password';
export { default as RecoverPassword } from './recover_password';
